// hooks
import useModalData from 'hooks/useShowModal'
// types
import { Modals } from 'constants/modals'
import { IFieldLink, IFieldLinkSettings, IRisk } from 'types/graphql'

export const useFormsLinking = () => {
  const {
    hideModal,
    modalData: { isOpen, isLinking, fieldLink, onAddClick }
  } = useModalData<{ isLinking: boolean; fieldLink?: IFieldLink; onAddClick: (risk: IRisk) => Promise<void> }>({
    modalType: Modals.LINKED_FORM_VIEW_MODAL
  })

  if (!isOpen) {
    return {
      isLinking: false,
      isFormView: false,
      linkingSettings: {} as IFieldLinkSettings
    }
  }

  return {
    isLinking,
    hideModal,
    onAddClick,
    isFormView: isOpen,
    fieldLinkId: fieldLink?.id,
    linkingSettings: fieldLink?.linkingSettings
  }
}
